<et-step-layout [data]="data">
  <div class="flex flex-column">
    <span class="title3Font"
          i18n>Authors</span>
    <div class="flex align-items-baseline mb-4">
      <span i18n>All of the authors of the paper should be listed in the table</span>
      @if (!isReadonly) {
        <div class="ml-auto">
          <p-button label="Create author"
                    styleClass="p-button-outlined"
                    (onClick)="createAuthor()">
          </p-button>
          <p-button label="Search authors"
                    styleClass="p-button-outlined"
                    class="ml-3"
                    (onClick)="searchAuthors()">
          </p-button>
        </div>
      }
    </div>

    @if (tableSettings) {
      <p-table [scTableSettings]="tableSettings">
        @if (!isReadonly; as rowData) {
          <ng-template pTemplate="row-actions"
                       let-rowData>
            @if (!rowData.corresponding) {
              <i class="fas fa-trash"
                 (click)="onAuthorRemoved(rowData.memberId)"
                 pTooltip="Click to remove author"
                 tooltipPosition="top"
                 i18n-pTooltip></i>
            }
          </ng-template>
        }
      </p-table>
    }

    @if (existingAuthors.length) {
      <span class="mb-4 mt-6"
            i18n> There are accounts ({{ existingAuthors.length }}) with such emails, please select which add to
        table
      </span>
      @for (existingAuthor of existingAuthors; track trackByFunc($index, existingAuthor)) {
        <et-author-entry [author]="existingAuthor"
                         [countries$]="countries$"
                         [titles$]="titles$"
                         [isOrcidIdUnusedExpression]="data.isMemberOrcidIdUnused"
                         (authorAdded)="onParsedAuthorAdded($event, false)"
                         (authorRemoved)="onParsedAuthorRemoved($event, false)">
        </et-author-entry>
      }
    }

    @if (newAuthors.length) {
      <span class="mb-4 mt-6"
            i18n>Provide more information to add this authors in the table</span>
      @for (newAuthor of newAuthors; track trackByFunc($index, newAuthor)) {
        <et-author-entry [author]="newAuthor"
                         [countries$]="countries$"
                         [titles$]="titles$"
                         [isOrcidIdUnusedExpression]="data.isMemberOrcidIdUnused"
                         [isEmailUnusedExpression]="data.isMemberEmailUnused"
                         (authorAdded)="onParsedAuthorAdded($event, true)"
                         (authorRemoved)="onParsedAuthorRemoved($event, true)">
        </et-author-entry>
      }
    }
  </div>
</et-step-layout>